import { getTickPositions, getChartDateFormat, getXAxisTitleText, getValueOfToolTip, } from '@hems/user/src/containers/report/chartFunctions';
export function getGridOptions(tabname, locale, data, t) {
    return {
        chart: {
            type: 'column',
            height: 480,
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'top',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                fontWeight: 'regular',
            },
        },
        yAxis: [
            {
                offset: 20,
                labels: {
                    style: {
                        color: '#434348',
                    },
                    formatter() {
                        return `${this.value}k`;
                    },
                },
                title: {
                    text: `${t('common.energy')}(Wh)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                opposite: true,
                min: 0,
                tickAmount: 6,
            },
        ],
        xAxis: [
            {
                title: {
                    text: getXAxisTitleText(tabname, t),
                    align: 'high',
                },
                labels: {
                    autoRotation: [0],
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
                tickPositions: getTickPositions(tabname, data.demandData.map((item) => item.x)),
            },
        ],
        tooltip: {
            shared: true,
            formatter() {
                return getValueOfToolTip(tabname, this, locale, t);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                grouping: true,
            },
        },
        series: [
            {
                type: 'column',
                yAxis: 0,
                name: t('device.exported'),
                color: '#fd8714',
                data: data.feedInData,
            },
            {
                type: 'column',
                name: t('device.imported'),
                color: '#f05538',
                data: data.demandData,
            },
        ],
        scrollbar: {
            enabled: true,
        },
        navigator: {
            xAxis: {
                labels: {
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
            },
        },
        noData: {
            position: {},
            attr: {},
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#202030',
            },
        },
    };
}
